import React, { Fragment, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import logoimg from '../../assets/images/logo.png';
import transp from '../../assets/images/transp.png'
import { Navigate } from 'react-router-dom';
import '../../styles/header.scss';
import { slide as Menu } from 'react-burger-menu';
import UserService from '../../services/users';

function Header() {
    const [redirectToHome, setRedirectToHome] = useState(false);

    const logout = async () => {
        await UserService.logout();
        setRedirectToHome(true);
    }

    if (redirectToHome) {
        return (
            <Navigate to={{ pathname: "/" }} />
        )
    }

    return (
        <Fragment>
            <header className='header'>
                <Row xs={2} lg={3}>
                    <Col xs={10} lg={3}>
                        <a href="/transparencia/restrito" alt="Portal da Transparência do Município de Macuco">
                            <img src={logoimg} className='logo' alt="Portal da Transparência do Município de Macuco" />
                        </a>
                    </Col>
                    <Col xs={10} lg={5}>
                        <a href="/transparencia/restrito" alt="Portal da Transparência do Município de Macuco">
                            <img src={transp} className='transp' alt="Portal da Transparência do Município de Macuco" />
                        </a>
                    </Col>
                </Row>
                <Menu right>
                    <a className="menu-item" href="#" onClick={e => logout()}>Sair</a>
                </Menu>
            </header>
        </Fragment >

    )
}

export default Header;